

import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { getAttachmentFilename } from '@utils/attachment';

type Props = ButtonProps & {
  filename?: boolean;
}

const DownloadLinkButton = ({ children, filename, ...rest }: Props) => {
  if (!rest.href) return null;

  return (
    <Button variant="link" target="_blank" rel="noreferrer noopener" {...rest}>
      <FontAwesomeIcon icon={faDownload} className="me-2" />
      {filename ? getAttachmentFilename(rest.href) : children}
    </Button>
  );
};

export { DownloadLinkButton };
